
export class RequestDelete {

  handshake?: string | null;
  applicationId?: string | null;
  moduleId?: string | null;
  id?: string;
}

export class RequestDeleteIds {

  handshake?: string | null;
  applicationId?: string | null;
  moduleId?: string | null;
  ids?: string [] | null;
}
